import React from 'react';

import {floatPriceFromFormatted} from '@optimaxdev/utils';
import {connect} from 'react-redux';

import {Price} from 'components/price/price';
import {PRODUCT_TYPES} from 'constants/product';
import {getPackageBasicData} from 'desktop/components/cartItemHelper/packageItems/packageItems';
import {ApplicationStoreType} from 'desktop/store';
import {CheckoutItemOptionType, CheckoutItemType} from 'desktop/types/checkoutItemsType';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {getPackageTitle} from 'libs/utils/utils';

import {useGetIsShowTBD} from '../../hooks/useGetIsShowTBD/useGetIsShowTBD';
import {getOrderReviewItemTaxById} from '../../store/selectors/orderReviewTotals/orderReviewTotals';
import {CartItemDetailsRow} from '../cartItemDetailsRow/cartItemDetailsRow';
import {CartItemLensesDetailsRow} from '../cartItemDetailsRow/cartItemLensesDetailsRow';
import {PrescriptionDetails} from '../prescriptionDetails/prescriptionDetails';

import s from './cartItemDetails.scss';

export type PropsType = {
    item: CheckoutItemType;
    salesTax: number;
};

const NON_PRESCRIPTION = 'Frame';

const isPriceZero = (price: number) => !price || floatPriceFromFormatted(price) === 0;

/**
 * Cart Item Details for checkout page
 *
 * @constructor
 */
export const CartItemDetails: React.FC<PropsType> = ({item, salesTax}) => {
    const isShowTBD = useGetIsShowTBD();
    const {is_logged_in: isLogged} = useGetCustomerData();

    return (
        <section className={s.wrapper}>
            {Object.values(item.options)
                .sort((a, b) => a.option.sort - b.option.sort)
                .map(({description, finalPrice, option, price, sku, title, usageName}) => {
                    const value = sku === NON_PRESCRIPTION ? usageName : title;
                    if (item.product.type === PRODUCT_TYPES.CONTACT_LENSES)
                        return (
                            <CartItemLensesDetailsRow
                                item={item}
                                key={option.title}
                                title={option.title}
                            />
                        );
                    return (
                        <CartItemDetailsRow
                            description={
                                option.alias === 'package'
                                    ? getPackageBasicData({
                                          description,
                                          isEyeglasses:
                                              item.product.type === PRODUCT_TYPES.EYEGLASSES,
                                          options: item.options as {
                                              [key: string]: CheckoutItemOptionType;
                                          },
                                          title,
                                      }).description
                                    : getPackageTitle(
                                          sku,
                                          value || '',
                                          item.product.type === PRODUCT_TYPES.SUNGLASSES,
                                      )
                            }
                            finalPrice={finalPrice}
                            key={option.title}
                            price={price}
                            title={option.title}
                        />
                    );
                })}
            <CartItemDetailsRow
                description={
                    <>{isPriceZero(salesTax) && isShowTBD ? 'TBD' : <Price>{salesTax}</Price>}</>
                }
                title="Sales Tax"
            />
            {isLogged && item.prescription && (
                <CartItemDetailsRow
                    description={item.prescription.name}
                    title="Prescription type"
                />
            )}
            <PrescriptionDetails
                forLenses={item.product.type === PRODUCT_TYPES.CONTACT_LENSES}
                prescription={item.prescription}
                prescriptionType={item.contactLensPrescriptionType}
            />
        </section>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @param {PropsType} props - props
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType, props: {item: CheckoutItemType}) => ({
    salesTax: getOrderReviewItemTaxById(props.item.id)(store),
});

export const CartItemDetailsConnected = connect(mapStateToProps)(CartItemDetails);
